import React from "react";
import "fontsource-roboto";

import { MarkupParser } from "components/MarkupParser";

export const App = () => {
  return (
    <MarkupParser />
  );
}
